export const GET_SERVING_SIZE = 'GET_SERVING_SIZE';
export const GET_NUTRITION_FACTS = 'GET_NUTRITION_FACTS';
export const SORT_NUTRITION_FACTS = 'SORT_NUTRITION_FACTS';
export const GET_NUTRITION_UNITS = 'GET_NUTRITION_UNITS';
export const GET_NUTRITION_PIVOT_DATA = 'GET_NUTRITION_PIVOT_DATA';
export const GET_PRODUCT_SERVING_SIZE = 'GET_PRODUCT_SERVING_SIZE';
export const PUT_PRODUCT_NUTRITION_VALUES = 'PUT_PRODUCT_NUTRITION_VALUES';
